<script>
export default {
  name: "layout-foot"
}
</script>

<template>
  <div></div>
</template>

<style lang="scss" scoped>

</style>